import type { FC } from "react"

import { ProductFileTypeToLabel } from "../constants"

import { AttachFilesDialog } from "@/components/upload/AttachFilesDialog/AttachFilesDialog"
import type { FieldGroupEnum } from "@/graphql/codegen/graphql"
import { ReferenceTableName } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

interface AddProductFileDialogProps {
  onClose: () => void
  onRefresh: () => void
  productId: number | string
}

const documentTypeOptions: Option<FieldGroupEnum>[] = Object.entries(ProductFileTypeToLabel).map(([value, label]) => ({
  value: value as FieldGroupEnum,
  label,
}))

export const AddProductFileDialog: FC<AddProductFileDialogProps> = ({ onClose, onRefresh, productId }) => (
  <AttachFilesDialog
    title='Upload Files'
    referenceTableName={ReferenceTableName.Product}
    referenceId={`${productId}`}
    documentTypeOptions={documentTypeOptions}
    successMessage='Product files uploaded'
    testIdPrefix='product-file'
    dialogTestId='product-file-dialog'
    onClose={onClose}
    onSuccess={onRefresh}
  />
)
